import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './toaststyle.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../img/sona_logo.jpg';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom'; // Using useHistory here
import { Breadcrumb } from 'react-bootstrap'; // Import Breadcrumb component

const Navbar = () => {
  const [logoutTriggered, setLogoutTriggered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const isLoggedIn = sessionStorage.getItem('userEmail');
  const userAccessLevel = parseInt(sessionStorage.getItem('access_level')) || 0; // Assume access level is stored in session
  const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes
  const location = useLocation(); // To get the current path

  const history = useHistory(); // useHistory for navigation

  let timeout;

  const resetTimeout = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => handleLogout(), INACTIVITY_TIMEOUT);
  };

  const handleGoBack = () => {
    history.goBack(); // Go back to the previous page
  };

  const handleLogout = () => {
    if (logoutTriggered) return;
    setLogoutTriggered(true);
    Swal.fire({
      icon: 'warning',
      title: 'Session Expired',
      text: 'You have been logged out due to inactivity. Please log in again.',
      confirmButtonText: 'OK',
      confirmButtonColor: '#007bff', // Professional blue button
      customClass: {
          popup: 'swal-popup-wave'
      }
  });
  
  
    setTimeout(() => {
      sessionStorage.clear();
      history.push('/login'); // Redirect to login page
    }, 1000);
  };

  useEffect(() => {
    if (isLoggedIn) {
      // Add activity listeners
      window.addEventListener('mousemove', resetTimeout);
      window.addEventListener('keydown', resetTimeout);

      // Set initial timeout
      resetTimeout();
    }

    return () => {
      // Cleanup listeners and timeout
      clearTimeout(timeout);
      window.removeEventListener('mousemove', resetTimeout);
      window.removeEventListener('keydown', resetTimeout);
    };
  }, [isLoggedIn]);

  const logout = () => {
    sessionStorage.clear(); // Clear session data
    history.push('/login'); // Redirect to login page
  };

  // Function to create breadcrumbs from the current path
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    const breadcrumbs = pathnames.map((value, index) => {
      const to = `/${pathnames.slice(0, index + 1).join('/')}`;
      return { label: value.charAt(0).toUpperCase() + value.slice(1), to }; // Capitalize the first letter of each segment
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Close dropdowns on path change or outside click
  useEffect(() => {
    setMenuOpen(false);
    setProfileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest('.dropdown')) {
        setMenuOpen(false);
        setProfileOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div className="fixed-top">
        <nav className="navbar navbar-expand-lg navbar-dark" style={{ height: '90px' }}>
          <div className='container'>
           
          <img
              src={logo}
              alt="Sona College Logo"
              className="img-fluid"
              style={{ width: '120px', height: '120px', marginRight: '10px', objectFit: 'contain' }}
            />
            <Link className='navbar-brand' to='/home'>
              <h3 style={{ fontSize: '20px' }}>
                R&D PORTAL
              </h3>
            </Link>

            <button
              className='navbar-toggler'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#navbarNav'
              aria-controls='navbarNav'
              aria-expanded='false'
              aria-label='Toggle navigation'
            >
              <span className='navbar-toggler-icon'></span>
            </button>
            <div className="collapse navbar-collapse ms-5" id="navbarNav" style={{ paddingTop: '0' }}>
              <ul className="navbar-nav mt-2 mb-0 mx-auto">
                {isLoggedIn && (
                  <>
                    <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/home">
                        <i className="fas fa-home"></i> Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/patenthome">
                        <i className="fas fa-gavel"></i> Patents
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/projects">
                        <i className="fas fa-tasks"></i> Projects
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/Publications1">
                        <i className="fas fa-book"></i> Publications
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/mou">
                        <i className="fas fa-file-signature"></i> MOU
                      </NavLink>
                    </li>
                    {/* <li className="nav-item">
                      <NavLink className="nav-link d-flex flex-column align-items-center" to="/sementic">
                        <i className="fas fa-search"></i> search
                      </NavLink>
                    </li> */}
                    <ul className="navbar-nav ms-auto">
                      {userAccessLevel < 6 && (
                        <li className={`nav-item dropdown mt-2 ${menuOpen ? 'show' : ''}`}>
                          <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDarkDropdownMenuLink"
                            role="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setMenuOpen(!menuOpen);
                              setProfileOpen(false);
                            }}
                            aria-expanded={menuOpen}
                          >
                            <i className="fas fa-bars"></i> Menu
                          </a>
                          <ul className={`dropdown-menu dropdown-menu-dark ${menuOpen ? 'show' : ''}`} aria-labelledby="navbarDarkDropdownMenuLink">
                            <li>
                              <Link className="dropdown-item" to="/departments">
                                <i className="fas fa-clipboard-list"></i> Departments
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/research-lab">
                                <i className="fas fa-flask"></i> Research Centre
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/user">
                                <i className="fas fa-users"></i> User
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/adminuser">
                                <i className="fas fa-book-open"></i> Faculty Contributions
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/role-master">
                                <i className="fas fa-user-shield"></i> Manage Authorization
                              </Link>
                            </li>
                            {/* <li>
                              <Link className="dropdown-item" to="/assign-role">
                                <i className="fas fa-tags"></i> Assign Role
                              </Link>
                            </li> */}
                            <li>
                              <Link className="dropdown-item" to="/target">
                                <i className="fas fa-check-circle"></i> Set Target
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="/alertall">
                                <i className="fas fa-bell"></i> Send Alert
                              </Link>
                            </li>
                          </ul>
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </ul>
              <ul className="navbar-nav ms-auto">
                {!isLoggedIn ? (
                  <li className="nav-item">
                    <NavLink className="nav-link d-flex flex-column align-items-center" to="/login">
                      <i className="fas fa-sign-in-alt"></i> Login
                    </NavLink>
                  </li>
                ) : (
                  <>
                    <li className={`nav-item dropdown ${profileOpen ? 'show' : ''}`}>
                      <a
                        className="nav-link dropdown-toggle d-flex align-items-center"
                        href="#"
                        id="profileDropdown"
                        role="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setProfileOpen(!profileOpen);
                          setMenuOpen(false);
                        }}
                        aria-expanded={profileOpen}
                      >
                        <img
                          src={sessionStorage.getItem('photo')}
                          alt="User"
                          className="rounded-circle"
                          style={{
                            width: '35px', // Smaller profile icon size
                            height: '35px',
                            objectFit: 'cover',
                            marginRight: '8px',
                          }}
                          onError={(e) => {
                            e.target.src = 'https://www.citypng.com/public/uploads/preview/hd-man-user-illustration-icon-transparent-png-11640168385tqosatnrny.png'; // Path to your default image
                          }}
                        />
                        <span style={{ fontSize: '0.85rem', color: '#fff' }}>
                          {sessionStorage.getItem('username')}
                        </span>
                      </a>
                      <ul
                        className={`dropdown-menu dropdown-menu-end p-2 ${profileOpen ? 'show' : ''}`}
                        aria-labelledby="profileDropdown"
                        style={{
                          minWidth: '260px', // Adjusted width for better alignment
                          backgroundColor: '#f8f9fa',
                          borderRadius: '6px',
                          boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-muted small" style={{ fontSize: '0.75rem', fontWeight: '700' }}>
                            SONA R&D Portal
                          </span>
                          <a
                            className="text-danger text-decoration-none small"
                            style={{ fontSize: '0.75rem', fontWeight: '550', cursor: 'pointer' }}
                            onClick={logout}
                          >
                            Sign out
                          </a>
                        </div>
                        <hr className="my-1" style={{ margin: '0.5rem 0' }} />
                        <div className="row align-items-center mb-2">
                          <div className="col-4 text-center">
                          <img
  src={sessionStorage.getItem('photo')}
  className="rounded-circle border"
  style={{
    width: '60px',
    height: '60px',
    objectFit: 'cover',
  }}
  onError={(e) => {
    e.target.src = 'https://www.citypng.com/public/uploads/preview/hd-man-user-illustration-icon-transparent-png-11640168385tqosatnrny.png'; // Path to your default image
  }}
/>
                          </div>
                          <div className="col-8 ps-0">
                            <h6 className="mb-0" style={{ fontSize: '0.8rem', fontWeight: '640' }}>
                              {sessionStorage.getItem('username')}
                            </h6>
                            <small
                              className="text-muted"
                              style={{
                                fontSize: '0.7rem',
                                fontWeight: '650',
                              }}
                            >
                              {sessionStorage.getItem('designation')}
                            </small>
                          </div>
                        </div>
                        <hr className="my-1" style={{ margin: '0.5rem 0' }} />
                        <div className="d-flex justify-content-between align-items-center">
                          <a
                            href="/usersts"
                            className="text-decoration-none"
                            style={{
                              fontSize: '0.8rem',
                              color: 'black',
                            }}
                          >
                            <i className="fas fa-user-circle me-1"></i> My Contributions
                          </a>
                          <a
                            href="/profile"
                            className="text-decoration-none"
                            style={{
                              fontSize: '0.8rem',
                              color: 'black',
                            }}
                          >
                            <i className="fas fa-cog fa-spin me-1"></i> Profile
                          </a>
                        </div>
                      </ul>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </nav>
      </div>

      {/* Breadcrumbs Section */}
      <div className="container" style={{ paddingTop: '100px' }}>
        
        <div className="d-flex align-items-center">
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/home' }}>Home</Breadcrumb.Item>
            {breadcrumbs.map((breadcrumb, index) => (
              <Breadcrumb.Item
                key={index}
                linkAs={Link}
                linkProps={{ to: breadcrumb.to }}
                active={index === breadcrumbs.length - 1}
              >
                {breadcrumb.label}
              </Breadcrumb.Item>
            ))}
            
          </Breadcrumb>
        </div>
        <i
            className="fas fa-arrow-left me-2"
            onClick={handleGoBack}
            style={{
              fontSize: '20px',
              cursor: 'pointer',
              color: '#000',
            }}
          />
      </div>
    </>
  );
};

export default Navbar;
